module.exports = __webpack_public_path__ + "img/brand (1).55eb96ee.png";